module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero7.png?982495b3";